import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Images } from "../Components/Images";
import { NavLink } from "react-router-dom";
import { getSiteSettings } from "../actions/settings";
import toast from "react-hot-toast";

import { subscribeUser } from "../actions/user";
import { API_URL } from "../Config";

const NewFooter = ({ cmsLits }) => {
  const [settingsData, setSettingsData] = useState();
  const [email, setEmail] = useState()
  const [value1, setValue1] = useState()

  const getSettingsData = async () => {
    try {
      let { status, message, result } = await getSiteSettings();

      if (status === "success") {
        setSettingsData(result);
      }
    } catch (err) { }
  };

  useEffect(() => {
    getSettingsData();
  }, []);


  useEffect(() => {
    if (cmsLits) {
      setValue1(cmsLits.find((value) => (value.identifier == 'Footer Content')))
    }
  }, [cmsLits]);

  const subscribeMail = async () => {
    try {
      let { status, message, result } = await subscribeUser({ emailId: email });
      console.log(
        "🚀 ~ getSettingsData ~ status, message, result:",
        status,
        message,
        result
      );
      if (status) {
        toast.success(message);
        setEmail();
      } else {
        toast.success(message);
        setEmail();
      }
    } catch (err) { }
  };

  const handleChange = async (e) => {
    try {
      setEmail(e.target.value);
    } catch (err) { }
  };

  return (
    <>
      <div className="new_footer">
        <Container className="custom_container">
          {/* <div className="footer_content"> */}
          {/* <div className="row"> */}
          {/* <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-3">
                <img src={API_URL + "/public/images/" + settingsData?.sitelogo} className="img-fluid logo" alt="" />

                <div className="socialLink">
                  {settingsData &&
                    settingsData?.socialLinks &&
                    settingsData?.socialLinks.length > 0
                    ? settingsData?.socialLinks?.map((item) => {
                      return (
                        <a href={item?.link} target="_blank">
                          {console.log(
                            API_URL + "/public/images/" + item.icon,
                            "API URL"
                          )}
                          <img
                            src={API_URL + "/public/images/" + item.icon}
                            className="img-fluid img-src"
                            alt={item.icon}
                          />
                        </a>
                      );
                    })
                    : ""} */}

          {/* <a href="#" target="_blank">
                    <img src={Images.twitter} className="img-fluid img-src" />
                  </a>
                  <a href="#" target="_blank">
                    <img src={Images.telegram} className="img-fluid img-src" />
                  </a>
                  <a href="#" target="_blank">
                    <img src={Images.instagram} className="img-fluid img-src" />
                  </a>
                  <a href="#" target="_blank">
                    <img src={Images.mail} className="img-fluid img-src" />
                  </a> */}

          {/* </div>
              </div> */}
          {/* <div className="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2 mb-3">
                <div>
                  <p className="title_txt mb-0">COMPANY</p>
                  <ul className="footer_navLinks">
                    <li className="">
                      <NavLink to="/">About Us</NavLink>
                    </li>
                    <li className="">
                      <NavLink to="/">Services</NavLink>
                    </li>
                    <li className="">
                      <NavLink to="/">Blog</NavLink>
                    </li>
                    <li className="">
                      <NavLink to="/">Team</NavLink>
                    </li>
                    <li className="">
                      <NavLink to="/">Contract</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2 mb-3">
                <div>
                  <p className="title_txt mb-0">PRODUCT</p>
                  <ul className="footer_navLinks">
                    <li className="">
                      <NavLink to="/supportTicket">Support Ticket</NavLink>
                    </li>
                    <li className="">
                      <NavLink to="/">New</NavLink>
                    </li>
                    <li className="">
                      <NavLink to="/">Upcoming</NavLink>
                    </li>
                    <li className="">
                      <NavLink to="/">Lorem ipsum</NavLink>
                    </li>
                    <li className="">
                      <NavLink to="/">Lorem ipsum</NavLink>
                    </li>
                   
                  </ul>
                </div>
              </div> */}
          {/* <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-3 mb-3"></div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-7 col-xl-6 mb-3 d-flex align-items-center justify-content-start justify-content-sm-end">
                <div>
                  <p className="mail_title_txt mb-0">{value1?.heading}</p>
                  <p className="sub_title_txt mb-0">
                    {value1?.content}
                  </p>
                  <div className="emailInp">
                    <input
                      type="email"
                      placeholder="Your email"
                      className=""
                      onChange={(e) => handleChange(e)}
                    />
                    <button
                      className="send_btn cmn_blueBtn"
                      onClick={() => subscribeMail()}
                    >
                      Subscribe
                    </button>
                  </div>

                  <div className="note_content mt-2 d-flex align-items-baseline">
                    <p className="note_title mb-0 text-nowrap me-1">Note : </p>
                    <p className="note_val mb-0 mt-1">
                      {" "}
                      The profit is based on the liquidity reserves and market
                      oppurtunities
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
          {/* </div> */}
          {/* <hr className="custom_hr" /> */}
          <div className="copyRight_sec mt-4">
            <img src={Images.logo} className="img-fluid footlogo" alt="" />
            <div className="navLink_sec">
              <NavLink to="/supportTicket">Support Ticket</NavLink>
              <NavLink target={"_blank"} to={`${API_URL}/public/images/TermsConditions.pdf`} rel="noopener noreferrer">
                Terms of Services
              </NavLink>

              <NavLink to={`${API_URL}/public/images/PrivacyPolicy.pdf`} target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </NavLink>

              <NavLink to="/cookies">Cookies</NavLink>
            </div>
          </div>
          <p className="foottext">
            Copyright 2025 Sector-8. Inc.
          </p>
        </Container >
        {/* <img src={Images.footerBg} className="img-fluid footerBgImg" /> */}
      </div >
    </>
  );
};

export default NewFooter;
